import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useApolloClient, useQuery } from "react-apollo";

import { Content, Button, Control, Field } from "rbx";

import Loading from "../../../components/Loading";
import { ModalContext } from "../../../components/ModalProvider";
import { DELETE_ITEM_MUTATION } from "../../../graphql/Items/Items.graphql";
import { ALL_ITEM_TRANSACTIONS_QUERY } from "../../../graphql/Items/ItemTransactions.graphql";
import { ALL_WORK_ORDER_PARTS_QUERY } from "../../../graphql/WorkOrders/WorkOrderParts.graphql";
import {
  ALL_ITEM_VENDORS_QUERY,
  DELETE_ITEM_VENDOR_MUTATION
} from "../../../graphql/Vendors/ItemVendors.graphql";

import { DeleteButton } from "../../../components/inputs";

const ConfirmItemDelete = ({ id, history }) => {
  const { setModalOpen } = useContext(ModalContext);
  const client = useApolloClient();

  const { data: transationData } = useQuery(ALL_ITEM_TRANSACTIONS_QUERY, {
    variables: {
      where: {
        ItemRecIdRef: parseInt(id)
      }
    }
  });

  const { data: workOrderPartsData } = useQuery(ALL_WORK_ORDER_PARTS_QUERY, {
    variables: {
      where: {
        ItemRecIdRef: parseInt(id)
      }
    }
  });

  const handleCancel = async () => {
    setModalOpen(false, "");
  };

  const handleComplete = async () => {
    const { data: itemVendorData } = await client.query({
      query: ALL_ITEM_VENDORS_QUERY,
      variables: { where: { ItemRecIdRef: parseInt(id, 10) } }
    });
    const itemVendors = itemVendorData?.VW_ItemVendors;
    if (Array.isArray(itemVendors)) {
      await Promise.all(
        itemVendors.map(iv =>
          client.mutate({
            mutation: DELETE_ITEM_VENDOR_MUTATION,
            variables: { where: { RecId: iv.RecId } }
          })
        )
      );
    }
    history.push("/inventory/items");
    setModalOpen(false, "");
  };

  if (!transationData?.ItemTransactions || !workOrderPartsData?.WorkOrderParts)
    return <Loading />;

  // cannot delete if item is on transaction or work order
  // if able to delete, display confirmation modal

  if (
    transationData.ItemTransactions.length ||
    workOrderPartsData.WorkOrderParts.length
  ) {
    return (
      <div
        style={{
          width: 400,
          padding: 5
        }}
      >
        <Content size="medium" textAlign="centered">
          <p>
            This Item is on a Transaction or Work Order record and cannot be
            deleted. However, it may be made inactive.
          </p>
        </Content>

        <Field align="centered" kind="group">
          <Control>
            <Button color="primary" size="small" onClick={handleCancel}>
              OK
            </Button>
          </Control>
        </Field>
      </div>
    );
  }
  return (
    <div
      style={{
        width: 400,
        padding: 5
      }}
    >
      <Content size="medium" textAlign="centered">
        <p>Are you sure you want to delete this item?</p>
      </Content>
      <Field align="centered" kind="group">
        <Control>
          <DeleteButton
            mutation={DELETE_ITEM_MUTATION}
            refetchQueries={["ALL_ITEMS_QUERY", "SINGLE_ITEM_QUERY"]}
            size="small"
            variables={{
              where: {
                RecId: parseInt(id)
              }
            }}
            onComplete={handleComplete}
          />
        </Control>
        <Control>
          <Button color="primary" size="small" onClick={handleCancel}>
            Cancel
          </Button>
        </Control>
      </Field>
    </div>
  );
};

ConfirmItemDelete.propTypes = {
  id: PropTypes.string,
  history: PropTypes.object
};

export default ConfirmItemDelete;
